import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import * as _ from "lodash";
import simplebar from "simplebar-vue";
//SYSTEM
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import CredMixer from "@/router/views/CredMixer";
import { toaster } from "@/utilities/toaster";
import { interpret } from "xstate";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
import SkeletonLoaderProjectOverview from "@/components/SkeletonLoaderProjectOverview.vue";
import { DataSet, Network } from "vis-network/standalone";
import projectTagsMachine from "./machines/projectTagsMachine";
import { ProjectTagModule } from "@/store/modules/projectTag.module";
import MultiSelectComponent from "@/components/widgets/MultiSelectComponent.vue";
import Swal from "sweetalert2";
Component.registerHooks(["metaInfo"]);
let ProjectTags = /** @class */ (() => {
    let ProjectTags = class ProjectTags extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Project Tags";
            this.isOpen = false;
            this.isTeamLead = false;
            this.isAssignMode = true;
            this.projectTreeFilterType = "";
            this.applyToAllSubProjects = false;
            this.canUnassignTagFromAllSubProjects = false;
            this.tagsToAssign = [];
            this.assignedTags = [];
            this.inheritedTags = [];
            this.selectedRootProjects = [];
            this.selectedTeam = null;
            this.selectedMembers = [];
            this.selectedTags = [];
            this.container = null;
            this.network = null;
            this.nodes = new DataSet();
            this.edges = new DataSet();
            this.projectsLoadedForProjectTree = [];
            this.showfullscreen = false;
            this.projectSearchText = "";
            this.memberSearchText = "";
            this.tagSearchText = "";
            this.machine = projectTagsMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.state;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "PMO",
                    href: "#",
                },
                {
                    text: "Project Tags",
                    active: true,
                },
            ];
        }
        send(event) {
            this.machineService.send(event);
        }
        //new implementation
        get inFullScreenMode() {
            const doc = document;
            doc.body.classList.toggle("fullscreen-enable");
            // const fullScreenMode = !(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement);
            // return fullScreenMode;
            return !(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement);
        }
        get isPerformingTagOperation() {
            return this.state.hasTag("assigningTag") || this.state.hasTag("unassigningTag");
        }
        get projects() {
            return ProjectTagModule.projects ?? [];
        }
        get projectsForFilter() {
            return ProjectTagModule.projectsForFilter ?? [];
        }
        get rootProjects() {
            return ProjectTagModule.rootProjects ?? [];
        }
        get hasProjects() {
            return this.projects && this.projects.length > 0;
        }
        get hasProjectsForFilter() {
            return this.projectsForFilter && this.projectsForFilter.length > 0;
        }
        get hasRootProjects() {
            return this.rootProjects && this.rootProjects.length > 0;
        }
        get hasMultipleRootProjects() {
            return this.hasRootProjects && this.rootProjects.length > 1;
        }
        get hasProjectTrees() {
            return this.projectTrees && this.projectTrees.size > 0;
        }
        get projectTrees() {
            return ProjectTagModule.projectTrees;
        }
        get project() {
            return ProjectTagModule.project;
        }
        get isApexProject() {
            return this.project?.isApexProject ?? false;
        }
        get sortedMembersForOwner() {
            if (this.project?.members) {
                return _.sortBy(this.project?.members, (item) => item.fullName);
            }
            return [];
        }
        get membersForOwner() {
            return this.sortedMembersForOwner.filter((x) => x.employeeId != this.project.ownedBy && x.isActiveMember);
        }
        get projectOwner() {
            return this.project?.members?.find((x) => x.employeeId == this.project.ownedBy);
        }
        get isProjectOwner() {
            return this.project?.isProjectOwner ?? false;
        }
        get teams() {
            return ProjectTagModule.teams?.map((x) => ({ id: x.id, value: x.name, isSelected: true })) ?? [];
        }
        get members() {
            return ProjectTagModule.members;
            // let _members: IprojectMemberInfoDTO[] = [
            //     {
            //         id: Guid.parse('691D26F8-5C89-48F3-967D-0F65A6CC702F'),
            //         name: 'Arun GK',
            //         isActive: true,
            //     },
            //     {
            //         id: Guid.parse('38523B1D-9456-424E-A5EE-CE76CBAEAA9C'),
            //         name: 'Ram Kumar',
            //         isActive: true,
            //     },
            //     {
            //         id: Guid.parse('05059118-3DB4-408A-A323-DE0DB443B8C7'),
            //         name: 'Raj Kumar',
            //         isActive: true,
            //     },
            // ];
            // return _members;
        }
        get tags() {
            return ProjectTagModule.tags;
        }
        get projectTags() {
            return ProjectTagModule.projectTags;
        }
        get hasMembers() {
            return this.members && this.members.length > 0;
        }
        get hasTags() {
            return this.tags && this.tags.length > 0;
        }
        get hasProjectTags() {
            return this.projectTags && this.projectTags.length > 0;
        }
        get hasAvailableTags() {
            return this.availableTags && this.availableTags.length > 0;
        }
        get hasTagsToAssign() {
            return this.tagsToAssign && this.tagsToAssign.length > 0;
        }
        get hasAssignedTags() {
            return this.assignedTags && this.assignedTags.length > 0;
        }
        get hasInheritedTags() {
            return this.inheritedTags && this.inheritedTags.length > 0;
        }
        get noItemsAvailable() {
            return !this.hasProjectsForFilter && !this.hasMembers && !this.hasTags;
        }
        get hasFilteredProjects() {
            return this.filteredProjects && this.filteredProjects?.length > 0;
        }
        get hasFilteredMembers() {
            return this.filteredMembers && this.filteredMembers.length > 0;
        }
        get hasFilteredTags() {
            return this.filteredTags && this.filteredTags.length > 0;
        }
        get projectsForTeam() {
            if (!this.hasProjectsForFilter || !this.selectedTeam)
                return [];
            return this.projectsForFilter?.filter((project) => project.teams.includes(this.selectedTeam.toString()))?.map((x) => ({ id: x.id, value: x.name, code: x.code.toString(), isSelected: true })) ?? [];
        }
        get hasProjectsForTeam() {
            return this.projectsForTeam && this.projectsForTeam.length > 0;
        }
        get filteredProjects() {
            let _projects = this.projectsForTeam;
            const search = this.projectSearchText.toLowerCase();
            if (search && search.length > 1) {
                return _projects.filter((p) => p.value?.toLowerCase().includes(search));
            }
            if (this.selectedRootProjects && this.selectedRootProjects.length > 0) {
                _projects = _projects.filter((project) => !this.selectedRootProjects.some((selected) => selected.id === project.id));
            }
            return _projects;
        }
        get membersForTeam() {
            if (!this.hasMembers || !this.selectedTeam)
                return [];
            return this.members?.filter((member) => member.teams.includes(this.selectedTeam.toString()))?.map((x) => ({ id: x.id, value: x.name, isSelected: true })) ?? [];
        }
        get hasMembersForTeam() {
            return this.membersForTeam && this.membersForTeam.length > 0;
        }
        get filteredMembers() {
            let _members = this.membersForTeam;
            const search = this.memberSearchText.toLowerCase();
            if (search && search.length > 1) {
                return _members.filter((p) => p.value?.toLowerCase().includes(search));
            }
            if (this.selectedMembers && this.selectedMembers.length > 0) {
                _members = _members.filter((member) => !this.selectedMembers.some((selected) => selected.id === member.id));
            }
            return _members;
        }
        get tagsForTeam() {
            if (!this.hasTags || !this.selectedTeam)
                return [];
            return this.tags?.filter((tag) => tag.teamId === this.selectedTeam)?.map((x) => ({ id: x.id, value: x.name, code: x.color, isSelected: true })) ?? [];
        }
        get hasTagsForTeam() {
            return this.tagsForTeam && this.tagsForTeam.length > 0;
        }
        get filteredTags() {
            let _tags = this.tagsForTeam;
            const search = this.tagSearchText.toLowerCase();
            if (search && search.length > 1) {
                return _tags.filter((p) => p.value?.toLowerCase().includes(search));
            }
            if (this.selectedTags && this.selectedTags.length > 0) {
                _tags = _tags.filter((tag) => !this.selectedTags.some((selected) => selected.id === tag.id));
            }
            return _tags;
        }
        get canShowProjectFilter() {
            return (!this.selectedTeam && this.hasProjectsForFilter) || (this.selectedTeam && this.hasProjectsForTeam);
        }
        get canShowMemberFilter() {
            return (!this.selectedTeam && this.hasMembers) || (this.selectedTeam && this.hasMembersForTeam);
        }
        get canShowTagFilter() {
            return (!this.selectedTeam && this.hasTags) || (this.selectedTeam && this.hasTagsForTeam);
        }
        get searchText() {
            switch (this.projectTreeFilterType) {
                case "project":
                    return this.projectSearchText;
                case "member":
                    return this.memberSearchText;
                case "tag":
                    return this.tagSearchText;
                default:
                    return "";
            }
        }
        get hasSearchText() {
            return this.searchText.length > 0;
        }
        set searchText(value) {
            switch (this.projectTreeFilterType) {
                case "project":
                    this.projectSearchText = value;
                case "member":
                    this.memberSearchText = value;
                case "tag":
                    this.tagSearchText = value;
            }
        }
        get searchTextPlaceholder() {
            switch (this.projectTreeFilterType) {
                case "project":
                    return "Search by root project name...";
                case "member":
                    return "Search by member name...";
                case "tag":
                    return "Search by tag name...";
                default:
                    return "";
            }
        }
        get availableItems() {
            switch (this.projectTreeFilterType) {
                case "project":
                    return this.filteredProjects ?? [];
                case "member":
                    return this.filteredMembers ?? [];
                case "tag":
                    return this.filteredTags ?? [];
                default:
                    return [];
            }
        }
        get selectedItems() {
            switch (this.projectTreeFilterType) {
                case "project":
                    return this.selectedRootProjects ?? [];
                case "member":
                    return this.selectedMembers ?? [];
                case "tag":
                    return this.selectedTags ?? [];
                default:
                    return [];
            }
        }
        get hasSelectedItems() {
            return this.selectedItems && this.selectedItems.length > 0;
        }
        get canClearProjectTreeFilter() {
            return this.selectedTeam && (this.hasSelectedItems || this.hasSearchText);
        }
        get canLoadProjectTree() {
            return !this.isLoadingProjectTree && this.hasSelectedItems;
        }
        get drawerName() {
            switch (this.projectTreeFilterType) {
                case "project":
                    return "Projects";
                case "member":
                    return "Members";
                case "tag":
                    return "Tags";
                default:
                    return "";
            }
        }
        get useDefaultColor() {
            return this.projectTreeFilterType !== "tag";
        }
        get selectedItemsInfo() {
            return `Selected (${this.selectedItems.length}):`;
        }
        get availableTags() {
            this.assignedTags = [];
            this.inheritedTags = [];
            let _tags = this.tags?.map((x) => ({ id: x.id, value: x.name, code: x.color, isSelected: true })) ?? [];
            if (this.hasProjectTags) {
                const projectTags = this.getProjectTags(this.selectedProjectId);
                if (projectTags) {
                    this.assignedTags = projectTags.filter((x) => x.isInherited == false).map((x) => ({ id: x.tagId, value: x.tagName, code: x.tagColor, isSelected: true }));
                    this.inheritedTags = projectTags.filter((x) => x.isInherited == true).map((x) => ({ id: x.tagId, value: x.tagName, code: x.tagColor, isSelected: true }));
                }
            }
            if (this.hasAssignedTags) {
                _tags = _tags.filter((tag) => !this.assignedTags.some((assignedTag) => assignedTag.id === tag.id));
            }
            if (this.hasTagsToAssign) {
                _tags = _tags.filter((tag) => !this.tagsToAssign.some((selected) => selected.id === tag.id));
            }
            return _tags;
        }
        get previouslySelectedTeams() {
            return ProjectTagModule.selectedTeams;
        }
        set previouslySelectedTeams(value) {
            ProjectTagModule.SetSelectedTeams(value);
        }
        get previouslySelectedProjectTrees() {
            return ProjectTagModule.selectedProjectTrees;
        }
        set previouslySelectedProjectTrees(value) {
            ProjectTagModule.SetSelectedProjectTrees(value);
        }
        get previouslySelectedMembers() {
            return ProjectTagModule.selectedMembers;
        }
        set previouslySelectedMembers(value) {
            ProjectTagModule.SetSelectedMembers(value);
        }
        get previouslySelectedTags() {
            return ProjectTagModule.selectedTags;
        }
        set previouslySelectedTags(value) {
            ProjectTagModule.SetSelectedTags(value);
        }
        get selectedProjectId() {
            return ProjectTagModule.selectedProjectId;
        }
        set selectedProjectId(value) {
            ProjectTagModule.SetSelectedProjectId(value);
        }
        get canShowloadProjectTreeModal() {
            return this.state.hasTag("selectProjectTree");
        }
        get performingTagOperation() {
            return this.state.hasTag("assigningTag") || this.state.hasTag("unassigningTag");
        }
        get canShowManageTagModal() {
            return this.state.hasTag("assignTag") || this.state.hasTag("unassignTag");
        }
        get canAddTag() {
            return this.isTeamLead && this.hasAvailableTags;
        }
        get canDeleteTag() {
            return this.isTeamLead;
        }
        get isAccessDenied() {
            return this.state.hasTag("appUserIsNotTeamLead") || this.state.hasTag("noProjectAvailable");
        }
        get noFilteredProjectAvailable() {
            return this.state.hasTag("noFilteredProjectAvailable");
        }
        get isLoadingProjectTree() {
            return this.state.hasTag("gettingTeamsProjectsMembersAndTags") || this.state.hasTag("loadingProjectTree") || this.state.hasTag("gettingProjects");
        }
        get isRebuildingProjectTree() {
            return this.state.hasTag("rebuildProjectTree");
        }
        get isProjectTreeLoaded() {
            return this.state.hasTag("projectTreeLoaded");
        }
        get isProjectLoading() {
            return this.state.hasTag("gettingProjectInfo");
        }
        get isProjectLoaded() {
            return this.state.hasTag("projectLoaded");
        }
        get canShowProjectInfo() {
            return !this.showfullscreen && !this.noFilteredProjectAvailable && (this.canShowManageTagModal || this.performingTagOperation || this.isProjectLoading || this.isProjectLoaded);
        }
        get parentProject() {
            return ProjectTagModule.parentProject;
        }
        get projectTotalTimeSpent() {
            if (this.project.timeSpent > 0) {
                let value = this.project.timeSpent / 60;
                let hours = Math.floor(value / 60);
                let minutes = value % 60;
                let formattedMinutes = minutes.toFixed(0);
                return hours + "Hrs " + formattedMinutes + "m";
            }
            return 0 + "Hr " + 0 + "m";
        }
        get options() {
            return {
                // edges: {
                //     //width: 2,
                //     smooth: {
                //         type: "cubicBezier",
                //         forceDirection: "vertical",
                //         roundness: 0.4,
                //     },
                // },
                groups: {
                    project: {
                        color: "#74788D",
                        shape: "box",
                        size: 12,
                        font: {
                            size: 14,
                            color: "#FFFFFF",
                        },
                        borderWidth: 1,
                    },
                    tag: {
                        shape: "ellipse",
                    },
                },
                layout: {
                    improvedLayout: true,
                    hierarchical: {
                        direction: "UD",
                        sortMethod: "directed",
                        blockShifting: false,
                        treeSpacing: 1000,
                        nodeSpacing: 420,
                        levelSeparation: 300,
                        shakeTowards: "roots",
                        parentCentralization: true,
                    },
                },
                interaction: {
                    dragNodes: true,
                    dragView: true,
                    hideEdgesOnDrag: false,
                    hideEdgesOnZoom: false,
                    hideNodesOnDrag: false,
                    hover: true,
                    hoverConnectedEdges: false,
                    keyboard: {
                        enabled: true,
                        speed: { x: 10, y: 10, zoom: 0.02 },
                        bindToWindow: true,
                        autoFocus: true,
                    },
                    multiselect: false,
                    navigationButtons: false,
                    selectable: true,
                    selectConnectedEdges: true,
                    tooltipDelay: 300,
                    zoomSpeed: 1,
                    zoomView: true,
                },
                physics: {
                    enabled: false,
                },
            };
        }
        goToProjectOverView(projectId, isViewable) {
            if (projectId != null) {
                if (isViewable) {
                    this.$router.push({ name: "ProjectOverview", params: { projectId: projectId } });
                }
                else {
                    Swal.fire({
                        text: "Sorry! You do not have access to view this Project.",
                        icon: "warning",
                        confirmButtonColor: "#34c38f",
                        confirmButtonText: "Okay",
                    }).then(() => { });
                }
            }
        }
        resetTagOperation() {
            this.tagsToAssign = [];
            this.canUnassignTagFromAllSubProjects = true;
        }
        tagOperationPerformed() {
            toaster.ShowSuccess(`Tag(s) ${this.isAssignMode ? "assigned to" : "unassigned from"} this project ${this.applyToAllSubProjects ? "and all its sub projects" : ""} successfully!`);
        }
        checkTagCanUnassignFromAllSubProjects(tagId) {
            const projectTags = this.getProjectTags(this.selectedProjectId);
            return projectTags?.find((pt) => pt.tagId === tagId)?.assignedToAll ?? true;
        }
        onPerformingTagOperation(item) {
            this.resetTagOperation();
            this.applyToAllSubProjects = false;
            if (item) {
                this.tagsToAssign = [
                    {
                        id: item.id,
                        value: item.value,
                        code: item.code,
                        isSelected: true,
                    },
                ];
                this.canUnassignTagFromAllSubProjects = this.checkTagCanUnassignFromAllSubProjects(item.id);
            }
            this.machineService.send({ type: this.isAssignMode ? "ASSIGN_TAG" : "UNASSIGN_TAG" });
        }
        onAssigningTags() {
            this.isAssignMode = true;
            this.onPerformingTagOperation();
        }
        onUnassigningTag(item) {
            this.isAssignMode = false;
            this.onPerformingTagOperation(item);
        }
        manageTag() {
            const payload = {
                tagIds: this.tagsToAssign.map((tag) => tag.id),
                applyToAllSubProjects: this.applyToAllSubProjects,
                isAssignOperation: this.isAssignMode,
            };
            this.machineService.send({ type: this.isAssignMode ? "ASSIGNING_TAG" : "UNASSIGNING_TAG", payload: payload });
        }
        closeSelectedItemsDrawer() {
            var selectedItemsDrawer = this.$refs["selected-items-drawer"];
            selectedItemsDrawer.isShow = false;
        }
        closeAssignedTagsDrawer() {
            var assignedTagsDrawer = this.$refs["assigned-tags-drawer"];
            assignedTagsDrawer.isShow = false;
        }
        defaultProjectTreeFilterType() {
            if (this.selectedTeam) {
                this.projectTreeFilterType = this.hasProjectsForTeam ? "project" : this.hasMembersForTeam ? "member" : this.hasTagsForTeam ? "tag" : "";
            }
            else {
                this.projectTreeFilterType = this.hasProjectsForFilter ? "project" : this.hasMembers ? "member" : this.hasTags ? "tag" : "";
            }
        }
        resetProjectTreeFilterType() {
            switch (this.projectTreeFilterType) {
                case "project":
                    if (this.hasProjectsForTeam)
                        return;
                    break;
                case "member":
                    if (this.hasMembersForTeam)
                        return;
                    break;
                case "tag":
                    if (this.hasTagsForTeam)
                        return;
                    break;
            }
            this.defaultProjectTreeFilterType();
        }
        resetProjectTreeFilter() {
            this.selectedTeam = null;
            if (this.teams && this.teams.length === 1) {
                this.selectedTeam = this.teams[0].id;
            }
            this.defaultProjectTreeFilterType();
        }
        clearProjectTreeFilter() {
            this.projectSearchText = "";
            this.memberSearchText = "";
            this.tagSearchText = "";
            this.selectedRootProjects = [];
            this.selectedMembers = [];
            this.selectedTags = [];
        }
        loadAllProjects() {
            this.machineService.send({ type: "GETTING_TEAMS_PROJECTS_MEMBERS_TAGS" });
        }
        openLoadProjectTreeModal() {
            this.resetProjectTreeFilter();
            this.clearProjectTreeFilter();
            this.machineService.send({ type: "SELECT_PROJECT_TREE" });
        }
        closeLoadProjectTreeModal() {
            if (this.previousState.hasTag("noFilteredProjectAvailable")) {
                this.machineService.send({ type: "NO_FILTERED_PROJECT_AVAILABLE" });
            }
            else {
                this.machineService.send({ type: "CLOSE_MODAL" });
            }
        }
        closeManageTagModal() {
            this.resetTagOperation();
            this.machineService.send({ type: "CLOSE_MODAL" });
        }
        clearNodesAndEdges() {
            if (this.nodes) {
                this.nodes.clear();
            }
            if (this.edges) {
                this.edges.clear();
            }
        }
        getNodePosition(projectId) {
            if (this.network) {
                return this.network.getPosition(projectId);
            }
        }
        getSubProjectIds(projectId) {
            return this.edges
                .get()
                .filter((edge) => edge.from === projectId)
                .map((edge) => edge.to);
        }
        zoomToProjectAndSubProjects(projectId) {
            try {
                const subProjectIds = this.getSubProjectIds(projectId);
                const nodeIds = [projectId, ...subProjectIds];
                if (nodeIds) {
                    this.network.fit({
                        nodes: nodeIds,
                        animation: { duration: 1000, easingFunction: "easeInCubic" },
                    });
                }
            }
            catch (error) {
                console.error("Error focusing node:", error);
            }
        }
        getSubProjects(projectId, projects, visited = new Set()) {
            if (!projects)
                return [];
            if (visited.has(projectId)) {
                return [];
            }
            visited.add(projectId);
            let subprojects = projects.filter((p) => p.parentProjectId === projectId);
            return subprojects.flatMap((sub) => [sub, ...this.getSubProjects(sub.id, projects, visited)]);
        }
        loadProjectsForProjectTree() {
            if (this.hasProjectTrees) {
                // if ((!this.selectedRootProjects || this.selectedRootProjects.length === 0) && (this.rootProjects && this.rootProjects.length > 0)) {
                //     this.selectedRootProjects = this.getGuidsFromRootProjects();
                // }
                let projects = [];
                // console.log('projects:', this.projects);
                // console.log('rootProjects:', this.rootProjects);
                // console.log('projectTrees:', this.projectTrees);
                // if (this.selectedRootProjects && this.selectedRootProjects.length > 0) {
                //     //this.selectedProjectId = this.selectedRootProjects[0].id;
                //     this.selectedRootProjects.forEach((projectTree) => {
                //         const projectsForProjectTree = this.projectTrees.get(projectTree.id.toString()) ?? [];
                //         if (projectsForProjectTree && projectsForProjectTree.length > 0) {
                //             projectsForProjectTree.forEach(project => {
                //                 projects.push(project);
                //             });
                //         }
                //     });
                // } else {
                if (this.rootProjects && this.rootProjects.length > 0) {
                    //this.selectedProjectId = this.rootProjects[0].id;
                    this.rootProjects.forEach((projectTree) => {
                        const projectsForProjectTree = this.projectTrees.get(projectTree.id.toString()) ?? [];
                        if (projectsForProjectTree && projectsForProjectTree.length > 0) {
                            projectsForProjectTree.forEach((project) => {
                                projects.push(project);
                            });
                        }
                    });
                }
                // }
                return projects;
            }
            return [];
        }
        focusProjectNode(projectId) {
            if (this.network) {
                const focusOptions = {
                    position: this.getNodePosition(projectId),
                    scale: 1.75,
                    //offset: {x:100, y: 0},
                    animation: { duration: 1000, easingFunction: "easeInCubic" },
                };
                this.network.focus(projectId, focusOptions);
            }
        }
        handleProjectNodeClick(projectId) {
            console.log("Project node clicked:", projectId);
            if (projectId !== this.selectedProjectId) {
                this.selectedProjectId = projectId;
                this.machineService.send({ type: "GETTING_PROJECT_INFO" });
            }
            else {
                console.log("else [canShowProjectInfo]:", this.canShowProjectInfo);
                if (!this.canShowProjectInfo) {
                    this.machineService.send({ type: "PROJECT_LOADED" });
                }
            }
            if (this.selectedProjectId) {
                this.zoomToProjectAndSubProjects(this.selectedProjectId);
            }
        }
        handleClick(params) {
            if (params.nodes.length > 0) {
                if (!params.nodes[0].includes("tag")) {
                    const projectId = params.nodes[0];
                    this.handleProjectNodeClick(projectId);
                }
            }
        }
        networkInitialized() {
            this.network.fit();
            this.network.on("click", this.handleClick);
            this.machineService.send({ type: "PROJECT_TREE_LOADED" });
            if (this.selectedProjectId) {
                this.zoomToProjectAndSubProjects(this.selectedProjectId);
            }
        }
        getProjectTags(projectId) {
            let tags = [];
            if (this.hasProjectTags) {
                tags = this.projectTags.filter((x) => x.projectId === projectId);
            }
            return tags;
        }
        loadTreeNodes() {
            this.projectsLoadedForProjectTree = this.loadProjectsForProjectTree();
            //console.log("Projects loaded for project tree:", this.projectsLoadedForProjectTree);
            if (this.projectsLoadedForProjectTree) {
                if (this.projectsLoadedForProjectTree && this.projectsLoadedForProjectTree.length > 0) {
                    this.projectsLoadedForProjectTree.forEach((project) => {
                        try {
                            const projectId = project.id.toString();
                            if (!this.nodes.get(projectId)) {
                                this.nodes.add({
                                    id: projectId,
                                    label: project.name,
                                    group: "project",
                                    mass: 5,
                                });
                                if (project.parentProjectId && this.edges) {
                                    this.edges.add({
                                        from: project.parentProjectId.toString(),
                                        width: 2,
                                        to: projectId,
                                        arrows: "to",
                                    });
                                }
                            }
                        }
                        catch (error) {
                            console.error("Error adding node:", error);
                        }
                    });
                }
            }
        }
        destroyNetwork() {
            if (this.network !== null) {
                this.clearNodesAndEdges();
                this.network.destroy();
                this.network = null;
            }
        }
        initNetwork() {
            if (!this.container) {
                console.error("Container is undefined. Cannot initialize network.");
                return;
            }
            const data = { nodes: this.nodes, edges: this.edges };
            try {
                this.network = new Network(this.container, data, this.options);
            }
            catch (error) {
                console.error("Error initializing network:", error);
            }
            this.networkInitialized();
        }
        initContainer() {
            const el = this.$refs.network;
            if (!el || !(el instanceof HTMLElement)) {
                console.error("Network container not found or invalid:", el);
                return;
            }
            this.container = el;
        }
        rebuildProjectTree() {
            if (this.isRebuildingProjectTree) {
                if (this.applyToAllSubProjects) {
                    this.machineService.send({ type: "GETTING_PROJECT_TREE" });
                }
                else {
                    this.machineService.send({ type: "LOAD_PROJECT_TREE" });
                }
            }
        }
        renderProjectTree() {
            if (!this.projects || this.projects.length === 0)
                return;
            this.destroyNetwork();
            this.initContainer();
            this.loadTreeNodes();
            this.initNetwork();
        }
        getContrastColor(bgColor) {
            if (!bgColor)
                return "#000";
            // Convert hex to RGB
            const r = parseInt(bgColor.substring(1, 3), 16);
            const g = parseInt(bgColor.substring(3, 5), 16);
            const b = parseInt(bgColor.substring(5, 7), 16);
            // Calculate contrast (luminance formula)
            return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000" : "#fff";
        }
        getGuidsFromRootProjects() {
            return this.rootProjects?.map((x) => ({ id: x.id, value: x.name, code: x.code.toString(), isSelected: true })) ?? [];
        }
        getIdsFromSelectedRootProjects() {
            return this.selectedRootProjects?.map((x) => x.id.toString()) ?? [];
        }
        getIdsFromselectedMembers() {
            return this.selectedMembers?.map((x) => x.id.toString()) ?? [];
        }
        getIdsFromselectedTags() {
            return this.selectedTags?.map((x) => x.id.toString()) ?? [];
        }
        isProjectTreeSelectionChanged() {
            switch (this.projectTreeFilterType) {
                case "project":
                    return !(this.previouslySelectedProjectTrees.every((project) => this.getIdsFromSelectedRootProjects().includes(project)) && this.previouslySelectedProjectTrees.length === this.selectedRootProjects.length);
                case "member":
                    return !(this.previouslySelectedMembers.every((member) => this.getIdsFromselectedMembers().includes(member)) && this.previouslySelectedMembers.length === this.selectedMembers.length);
                case "tag":
                    return !(this.previouslySelectedTags.every((tag) => this.getIdsFromselectedTags().includes(tag)) && this.previouslySelectedTags.length === this.selectedTags.length);
            }
        }
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        }
        closeDropdown() {
            this.isOpen = false;
        }
        loadProjectTree() {
            if (!this.selectedTeam)
                return;
            this.previouslySelectedTeams = [this.selectedTeam.toString()];
            // if (this.projectTreeFilterType === "project" && this.selectedRootProjects.length === 0) {
            //     this.selectedRootProjects = this.getGuidsFromRootProjects();
            //     this.machineService.send({ type: "CLOSE_MODAL" });
            // } else {
            //const isSelectionChanged = this.isProjectTreeSelectionChanged();
            //if (isSelectionChanged) {
            switch (this.projectTreeFilterType) {
                case "project":
                    this.previouslySelectedProjectTrees = this.getIdsFromSelectedRootProjects();
                    this.machineService.send({ type: "GETTING_PROJECTS", payload: { teams: this.previouslySelectedTeams, projects: this.previouslySelectedProjectTrees } });
                    break;
                case "member":
                    this.previouslySelectedMembers = this.getIdsFromselectedMembers();
                    this.machineService.send({ type: "GETTING_PROJECTS", payload: { teams: this.previouslySelectedTeams, members: this.previouslySelectedMembers } });
                    break;
                case "tag":
                    this.previouslySelectedTags = this.getIdsFromselectedTags();
                    this.machineService.send({ type: "GETTING_PROJECTS", payload: { teams: this.previouslySelectedTeams, tags: this.previouslySelectedTags } });
                    break;
            }
            // } else {
            //     this.machineService.send({ type: "CLOSE_MODAL" });
            // }
            // }
        }
        handleButtonAction(event) {
            if (this.network) {
                const buttonId = event.currentTarget.id;
                switch (buttonId) {
                    case "zoomIn":
                        this.network.moveTo({ scale: this.network.getScale() * 1.2 });
                        break;
                    case "zoomOut":
                        this.network.moveTo({ scale: this.network.getScale() * 0.8 });
                        break;
                    case "moveLeft":
                        this.network.moveTo({ position: { x: this.network.getViewPosition().x - 50, y: this.network.getViewPosition().y } });
                        break;
                    case "moveRight":
                        this.network.moveTo({ position: { x: this.network.getViewPosition().x + 50, y: this.network.getViewPosition().y } });
                        break;
                    case "moveUp":
                        this.network.moveTo({ position: { x: this.network.getViewPosition().x, y: this.network.getViewPosition().y - 50 } });
                        break;
                    case "moveDown":
                        this.network.moveTo({ position: { x: this.network.getViewPosition().x, y: this.network.getViewPosition().y + 50 } });
                        break;
                    // case "refresh":
                    //     this.machineService.send({ type: "GETTING_PROJECT_TREE" });
                    //     break;
                    case "resetView":
                        this.network.fit();
                        break;
                    case "fullScreen":
                        const doc = document;
                        doc.body.classList.toggle("fullscreen-enable");
                        if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement) {
                            if (doc.documentElement.requestFullscreen) {
                                doc.documentElement.requestFullscreen();
                            }
                            else if (doc.documentElement.mozRequestFullScreen) {
                                doc.documentElement.mozRequestFullScreen();
                            }
                            else if (doc.documentElement.webkitRequestFullscreen) {
                                doc.documentElement.webkitRequestFullscreen();
                            }
                            this.showfullscreen = true;
                        }
                        else {
                            if (doc.cancelFullScreen) {
                                doc.cancelFullScreen();
                            }
                            else if (doc.mozCancelFullScreen) {
                                doc.mozCancelFullScreen();
                            }
                            else if (doc.webkitCancelFullScreen) {
                                doc.webkitCancelFullScreen();
                            }
                            this.showfullscreen = false;
                        }
                        break;
                    default:
                        break;
                }
            }
        }
        //Lifecycle;
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
        created() {
            this.machineService.machine.context.tagOperationPerformed = this.tagOperationPerformed.bind(this);
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                //console.log(this.state);
                if (this.state.hasTag("gettingProjectTree")) {
                    this.isTeamLead = true;
                }
                if (this.state.hasTag("gettingProjects") || this.state.hasTag("gettingProjectInfo") || this.state.hasTag("projectTreeLoaded") || this.state.hasTag("projectLoaded")) {
                    this.resetTagOperation();
                }
                if (!this.canShowloadProjectTreeModal) {
                    this.$bvModal.hide("load-project-tree");
                }
                if (!this.canShowManageTagModal) {
                    this.$bvModal.hide("manage-tag");
                }
                if (this.canShowloadProjectTreeModal) {
                    this.$bvModal.show("load-project-tree");
                }
                if (this.canShowManageTagModal) {
                    this.$bvModal.show("manage-tag");
                }
                if (this.isRebuildingProjectTree) {
                    this.rebuildProjectTree();
                }
                if (this.state.hasTag("loadingProjectTree")) {
                    this.$nextTick(() => {
                        this.renderProjectTree();
                    });
                }
            });
        }
        beforeDestroy() {
            this.destroyNetwork();
            ProjectTagModule.ClearAll();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    ProjectTags = __decorate([
        Component({
            name: "ProjectTags",
            components: {
                Loader,
                SectionLoader,
                Layout,
                PageHeader,
                BaseMixer,
                CredMixer,
                simplebar,
                MultiSelectComponent,
                SkeletonLoaderProjectOverview,
            },
        })
    ], ProjectTags);
    return ProjectTags;
})();
export default ProjectTags;
